var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataCompanyIconSelected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3338 11.7911C13.5442 11.7911 13.7213 11.7911 13.8874 11.7911V4.59464H10.339V11.7911H13.3338Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.236328 2.14786V3.4875H15.7363V2.14786L7.98633 0L0.236328 2.14786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63883 11.7911H5.63365V4.59464H2.08526V11.7911C2.25133 11.7911 2.42847 11.7911 2.63883 11.7911Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7363 15.2896C15.7363 14.3818 15.7363 13.8725 15.6035 13.6068C15.4817 13.3632 15.2824 13.1639 15.0388 13.0421C14.917 12.9757 14.7288 12.9425 14.4188 12.9314C14.131 12.9093 13.7988 12.9093 13.3449 12.9093H2.63883C2.1849 12.9093 1.85276 12.9093 1.57597 12.9314C1.26597 12.9536 1.07776 12.9868 0.9449 13.0532C0.701328 13.175 0.502042 13.3743 0.380257 13.6179C0.236328 13.8946 0.236328 14.3929 0.236328 15.3118V15.5H15.7363V15.2896Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataCompanyIconSelected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dataCompanyIconSelected.a19b0f887800492603a7460f496a1761.svg";